import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@auth0/auth0-angular';
import { getPortalVersion, PortalVersion } from 'src/app/portal-config';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-denied-dialog',
  templateUrl: './denied-dialog.component.html',
  styleUrls: ['./denied-dialog.component.scss']
})
export class DeniedDialogComponent implements OnInit {

  message:string;
  title: string;
  input:string;
  footermessage:string;
  logoutUrl: string;
  logoutOnClose: boolean;
  constructor(public dialogRef: MatDialogRef<DeniedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data:any, public auth: AuthService ) {
    this.title = data.title;
    this.message=data.message;
    this.input = data.input;
    this.logoutOnClose = typeof data.logoutOnClose == "boolean" ? data.logoutOnClose : true;
    this.footermessage = data.footermessage;
    if(data.footermessage){
      dialogRef.disableClose = true;
    }
   }

  ngOnInit(): void {
    this.logoutUrl = getPortalVersion() == PortalVersion.EOA ? environment.redirectUrlGL : environment.redirectUrlBroker;
  }

  closeDialog(): void{
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close();
  }
 

}
